export default __webpack_public_path__ + "static/exploring-4f61a79fa541074b3d937e02c6ddcd17.jpg";